import gql from 'graphql-tag';

export const TenantFragment = gql`
  fragment TenantFragment on Channel {
    tenant(search: $search) {
      id
      leases @include(if: $includeLeases) {
        leaseId
        suiteId
        suite {
          id
          name
          floors {
            id
            index
            name
          }
        }
      }
    }
  }
`;
